import script from "./Update.vue?vue&type=script&setup=true&lang=js"
export * from "./Update.vue?vue&type=script&setup=true&lang=js"

import "./Update.vue?vue&type=style&index=0&id=71dc1f56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71dc1f56"]])

export default __exports__